import { render, staticRenderFns } from "./AccessModal.vue?vue&type=template&id=d6dc2bd2&"
import script from "./AccessModal.vue?vue&type=script&lang=js&"
export * from "./AccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports